import { memo } from "react";
import { CellState } from "../types";
import styles from "./Cell.module.css";

interface CellProps {
  cell: CellState;
  onClick: (row: number, col: number) => void;
  isDragSource?: boolean;
  isDragTarget?: boolean;
}

function CellInner({ cell, onClick, isDragSource, isDragTarget }: CellProps) {
  if (cell.letter === null) {
    return <div className={styles.black} />;
  }

  const colorClass = styles[cell.color] || "";
  const selectedClass = cell.isSelected ? styles.selected : "";
  const lockedClass = cell.isLocked ? styles.locked : "";
  const dragSourceClass = isDragSource ? styles.dragSource : "";
  const dragTargetClass = isDragTarget ? styles.dragTarget : "";

  return (
    <button
      className={`${styles.cell} ${colorClass} ${selectedClass} ${lockedClass} ${dragSourceClass} ${dragTargetClass}`}
      onClick={() => onClick(cell.row, cell.col)}
      disabled={cell.isLocked}
      data-row={cell.row}
      data-col={cell.col}
      aria-label={`${cell.letter}, row ${cell.row + 1}, column ${cell.col + 1}, ${cell.color}`}
    >
      {cell.letter.toUpperCase()}
    </button>
  );
}

export const Cell = memo(CellInner, (prev, next) => {
  const a = prev.cell;
  const b = next.cell;
  return (
    a.letter === b.letter &&
    a.color === b.color &&
    a.isSelected === b.isSelected &&
    a.isLocked === b.isLocked &&
    a.row === b.row &&
    a.col === b.col &&
    prev.onClick === next.onClick &&
    prev.isDragSource === next.isDragSource &&
    prev.isDragTarget === next.isDragTarget
  );
});
